import { z } from "zod";
import { zUid } from "./zUid";
import { zDisplayId } from "./ZDisplayId";

export const zIdName = z.object({
  id: zUid,
  displayId: zDisplayId.nullish(),
  name: z.string(),
});
export type ZIdName = z.infer<typeof zIdName>;

export const zIdNameNumber = z.object({
  id: z.number(),
  name: z.string(),
});
export type ZIdNameNumber = z.infer<typeof zIdNameNumber>;

/**
 * Значение пропса fieldNames для компонента Select
 */
export const idNameFieldNames = { value: "id", label: "name" };
